module.exports = __webpack_public_path__ + "static/img/two.6e2cacb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/7/two.png
// module id = hhkf
// module chunks = 1